
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/website-component",
      function () {
        return require("private-next-pages/website-component.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/website-component"])
      });
    }
  